export interface QcResultCategory {
    containsWarnings?: boolean;
    containsFailures?: boolean;
    warningMessage?: string;
    failureMessage?: string;
    metrics: Array<QcResultMetric>;
}

export interface QcResultMetric {
    metric: string;
    value: string;
    type: string;
    ranges?: {
        fail?: QcResultRanges;
        warning?: QcResultRanges;
    };
    withinFailRange?: boolean;
    withinWarningRange?: boolean;
    failMessage?: string;
    warningMessage?: string;

}

export interface QcResultRanges {
    invert: boolean;
    conditions: Array<QcRangeCondition>;
}

export interface QcRangeCondition {
    type: QcRangeConditionType;
    value?: string;
    values?: Array<string>;
    indicatorMessage: string;
}

export class QcRangeConditionType {
    static LOW = 'low';
    static HIGH = 'high';
    static STATIC_VALUE = 'staticValue';
}
